export * from '@lskjs/log';
export { default } from '@lskjs/log';
